import { ReactElement } from 'react';
import { Icon, IconProps } from '@chakra-ui/react';
import { WarningIcon } from '@chakra-ui/icons';

export const FormIconError = (props: IconProps): ReactElement => (
  <Icon
    as={WarningIcon}
    position='absolute'
    top='50px'
    color='errors.200'
    right={{ base: '-25px', md: '-30px' }}
    sx={props}
    data-testid='error-icon'
  />
);
